export default __webpack_public_path__ + "static/media/Front-Poule-Dor-Koura.5df594df.jpg";